export default "__VITE_ASSET__Dlzuc2YH__"